import {
  required, between, digits, min,
} from '@validations'
import { alphanumeric } from '@/mixins/alphanumeric'
import ProfileApis from '@/services/apis/profile'

const userProfile = new ProfileApis()
export default {
  mixins: [alphanumeric],
  data() {
    return {
      pin_code: '',
      pin_code_confirmation: '',
      email: this.$route.query.email,
      token: this.$route.query.token,
      status: '',
      required,
      between,
      digits,
      min,
      pending: false,
    }
  },
  methods: {
    async submit() {
      const data = {
        token: this.token,
        email: this.email,
        pin_code: this.pin_code,
        pin_code_confirmation: this.pin_code_confirmation,
      }
      this.pending = true
      const response = await userProfile(data)
      this.showReaction(response)
      this.pending = false
      if (response.status === 422) {
        this.$router.push(`/${this.$i18n.locale}/token-expired`)
      } else if (response.status === 201) {
        this.$router.push('/')
      }
    },
  },
}
